import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { UserService } from "./user.service";
import { Permission, AdminPermission } from "./permission";

@Injectable({
  providedIn: "root",
})
export class PermissionGuard implements CanActivate {
  private excludedRoutes: string[] = [
    "/isf-school",
    "/student-certificate",
    "/certificate-dashboard",
    "/parent-dashboard",
    "/school-registration",
    "/student-registration",
  ];

  constructor(private userService: UserService, private router: Router) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const currentRoute = state.url;

    if (this.isExcludedRoute(currentRoute)) {
      return true;
    }

    const userRole = localStorage.getItem("roleId");

    if (userRole === "1") {
      // Super admin has unrestricted access
      return true;
    }

    if (userRole === "2") {
      const permission: Permission = route.data ? route.data.permission : null;
      if (!permission) {
        this.router.navigate(["/login"]);
        return false;
      }
      if (this.userService.isAuthorizedFor(permission)) {
        return true;
      }
      this.router.navigate(["/staffadmin/event-dashboard"]);
      return false;
    }

    this.router.navigate(["/login"]);
    return false;
  }

  private isExcludedRoute(route: string): boolean {
    return this.excludedRoutes.some((excluded) => route.startsWith(excluded));
  }
}
